
import { ref, toRefs, watch, inject, watchEffect } from "vue";
import SpecList from "./spec_list.vue";
import { useRouter } from "vue-router";
import { Toast } from "vant";
export default {
  components: {
    SpecList,
  },
  props: {
    modelValue: {
      type: String,
      default: "",
    },
    goods: {
      type: Object,
    },
    follow_status: {
      type: Number,
    },
    star_func: {
      type: Function,
    },
    addCart: {
      type: Function,
    },
    variation: {
      type: Boolean,
    },
    seckill:{
      type:String
    },
    seckill_btns:{
      type:Boolean
    }
  },
  setup(props: any, { emit }: any) {
    const $store: any = inject("$store");
    const $http: any = inject("$http");
    console.log("p----", props);

    const router: any = useRouter();
    let showModal = ref<any>(false);
    let { modelValue, goods, follow_status,seckill } = toRefs(props);
    let currencyUnit: String = $store.getSymbol();
    let stepperValue = ref(1);
    let larger = ref<string>(''); //默认图片
    let notify_status = ref(false);
    let visible = ref(false);
    //显示隐藏判断
    watch(modelValue, (state) => {
      showModal.value = state;
    });
    watch(showModal, (state) => {
      emit("update:modelValue", state);
    });
    let close = () => {
      showModal.value = false;
    };
    let pitch_image = (img: string) => {
      larger.value = img;
    };
    watchEffect(() => {
      if (goods.value.storage == 0) {
        let param = {
          goods_id: goods.value.id,
          search: ["subscribe"],
        };
        $http.get_notify(param).then((res: any) => {
          if (res.code === 200) {
            notify_status.value = res.data.subscribe;
          }
        });
      }
     
    });
    //订阅
    let notifyFn = async () => {
      if (goods.value.storage <= 0) {
        let params = {
          goods_id: goods.value.id,
          goods_name: goods.value.name.slice(0, 40) + "...",
          status: notify_status.value == false ? "on" : "off",
        };
        let ret = await $http.add_or_cancel_notify(params);
        if (ret.code === 200) {
          if (notify_status.value == false) {                           
            if (follow_status.value == 0 && notify_status.value == false) {        
              notify_status.value = true;
              visible.value = true;
            } else{
               showModal.value = false;
               notify_status.value = true
            }         
          } else {         
            notify_status.value = false;
            showModal.value = false;
          }
        }
      } else {
        if (!$store.getToken()) {
          Toast("Please log in "); 
          let str = null
          if(window.location.pathname.includes('/new')) {
            str = window.location.pathname.replace("/new","")
          } else {
            str = window.location.pathname
          }
          common.setStorage('redirect_url', str + window.location.search)
          setTimeout(() => {
            router.push("/login");
          });
        } else {
          emit("addCart", stepperValue.value);
          showModal.value = false;
        }
      }
    };
    let collect_fn = (val: string) => {
      if (val === "yes") {
        emit("star_func");
      }
      visible.value = false;
      showModal.value = false;
    };
    let placeOrder = ()=>{
        emit('variation_fuc')  
        emit("addCart", stepperValue.value);
    }
    return {
      showModal,
      close,
      stepperValue,
      currencyUnit,
      pitch_image,
      larger,
      notifyFn,
      notify_status,
      visible,
      collect_fn,
      placeOrder
    };
  },
};
